export default __webpack_public_path__ + "css/custom-forms.min.css";